var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuBurger = function SvgMenuBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 18a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2zM23 11a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2zM23 4a1 1 0 1 1 0 2H1a1 1 0 0 1 0-2z"
  })));
};
export default SvgMenuBurger;